import "./proyecto.a4a8b416.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire454f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire454f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $396Pf = parcelRequire("396Pf");

var $cT6zy = parcelRequire("cT6zy");

var $iPxtL = parcelRequire("iPxtL");
(0, $396Pf.createApp)({
    data () {
        return {
            items: null,
            loading: true
        };
    },
    mounted: async function() {
        const client = (0, $cT6zy.createClient)({
            projectId: "9fvagzap",
            dataset: "production",
            useCdn: true,
            apiVersion: "2023-05-03"
        });
        try {
            const posts = await client.fetch('*[_type == "proyectos"] | order(_updatedAt desc)');
            this.items = posts;
            this.loading = false;
        } catch (error) {
            console.log(error);
            this.loading = true;
        }
    },
    methods: {
        urlFor (source) {
            const builder = (0, (/*@__PURE__*/$parcel$interopDefault($iPxtL)))({
                projectId: "9fvagzap",
                dataset: "production"
            });
            return builder.image(source);
        }
    }
}).mount("#app");


//# sourceMappingURL=proyectos.02503450.js.map
